import type { PropRule } from './analytics-types.js';
import { COMPETITOR_CHANNEL_VALUES, COMPETITOR_SOURCE_VALUES } from './competitor-acquisition.js';

export function competitorAppEventProps<const Common extends Record<string, PropRule>>(common: Common) {
  const source = { ...common, competitor: COMPETITOR_SOURCE_VALUES, channel: COMPETITOR_CHANNEL_VALUES };
  const measured = { ...source, funnel_version: /^2026-09$/u };
  return {
    competitor_app_opened: { ...measured, entry: /^(draw|import|return)$/u },
    competitor_completion_shown: { ...measured, trigger: /^(draw|import)$/u },
    competitor_completion_clicked: { ...measured, action: /^(save|share)$/u },
    competitor_completion_dismissed: measured,
    competitor_switch_offer_shown: source,
    competitor_switch_import_clicked: source,
    competitor_switch_draw_clicked: source,
    competitor_switch_migration_help_clicked: source,
  };
}

export function competitorPageEventProps<
  const Common extends Record<string, PropRule>,
  const Attribution extends Record<string, PropRule>,
  const Diagnostics extends Record<string, PropRule>,
>(common: Common, attribution: Attribution, diagnostics: Diagnostics) {
  const measured = { ...common, competitor: COMPETITOR_SOURCE_VALUES, channel: COMPETITOR_CHANNEL_VALUES, funnel_version: /^2026-09$/u };
  const clicked = { ...measured, placement: new Set(['hero', 'content', 'footer']) };
  return {
    competitor_page_viewed: { ...measured, ...attribution },
    competitor_page_import_clicked: { ...clicked },
    competitor_page_draw_clicked: { ...clicked },
    competitor_page_migration_help_clicked: { ...clicked },
    competitor_page_runtime_error: { ...common, ...diagnostics },
    competitor_page_console_error: { ...common, ...diagnostics },
  };
}
